export default __webpack_public_path__ + "static/media/depositIcon.1da202b3.svg";